<template>
  <div class="min-h-screen bg-bochas-bg px-4 py-6 sm:py-8">
    <div class="max-w-7xl mx-auto">
      <div v-if="!userClubId" class="card-fbochas p-6 sm:p-8 text-center">
        <div
          class="w-14 h-14 rounded-full bg-bochas-rojo/20 flex items-center justify-center mx-auto mb-4"
        >
          <IconFbochas name="users" :size="28" color="#a52121" />
        </div>
        <h1 class="text-2xl font-bold text-white mb-2">
          No tenés un club asignado
        </h1>
        <p class="text-sm text-bochas-text-muted mb-4">
          Tu cuenta de admin de club todavía no está asociada a un club.
          Contactá a tu Federación o al administrador provincial para que te
          asignen uno.
        </p>
        <router-link to="/admin" class="btn-bochas-trans inline-block">
          Volver al panel
        </router-link>
      </div>
      <div v-else class="card-fbochas p-6 text-center">
        <div
          class="inline-block w-10 h-10 sm:w-12 sm:h-12 border-4 border-bochas-rojo border-t-transparent rounded-full animate-spin mb-4"
        ></div>
        <p class="text-sm text-bochas-text-muted">Cargando tu club...</p>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, onMounted } from "vue";
import { useRouter } from "vue-router";
import IconFbochas from "@/components/Icons/IconFbochas.vue";
import { getStoredUser } from "@/services/auth/authService";

const router = useRouter();

const userClubId = computed(() => getStoredUser()?.clubId || null);

onMounted(() => {
  if (userClubId.value) {
    // Redirigir al editor con el id del club del user.
    router.replace(`/admin/clubes/editar/${userClubId.value}`);
  }
});
</script>
